/**
 * Enum for history message segment types
 * Represents different formatting options for history messages
 *
 * @enum {string}
 *
 * @property {string} TEXT - Regular plain text content, rendered as <span>
 * @property {string} BOLD - Emphasized text with bold weight (700) and dark color, rendered as <strong>
 *                           Used for: action names, dates, targets, important values
 * @property {string} ITALIC - Secondary emphasis with italic style, rendered as <em>
 *                             Used for: supplementary information, reasons, notes
 * @property {string} VARIABLE - Dynamic/user-generated content with light blue background highlight, rendered as <span>
 *                               Used for: user input, dynamic values, placeholders
 * @property {string} LINEBREAK - Line break to separate sections, rendered as <br />
 *                                Used for: separating logical sections of multi-line messages
 *
 */
export enum HistorySegmentType {
  TEXT = "text",
  BOLD = "bold",
  VARIABLE = "variable",
  ITALIC = "italic",
  LINEBREAK = "linebreak",
}
